import { IMemberNonprofits } from '../../interfaces/companyProfile/iMemberNonprofits';
import { INonprofit } from '../../interfaces/iNonprofit'

export class MemberNonprofits implements IMemberNonprofits {
	nextPage: number;
	membersNonprofits: INonprofit[];

	constructor(memberNonprofits: IMemberNonprofits = {} as IMemberNonprofits) {
		this.nextPage = memberNonprofits.nextPage;
		this.membersNonprofits = memberNonprofits.membersNonprofits;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/companyProfile/memberNonprofits.ts